
      <div class="grid">
        <div class="col-12">
          <p-accordion>
            <p-accordionTab header="{{ 'NIVELES.LBL_HEADER' | translate}}" [selected]="true">
              <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
                <div class="grid form-group">
                  <div class="col-12 md:col-6 lg:col-6" *ngIf="!editando">
                    <div class="div-form">
                      <label for="codigo">* {{ 'LBL_CODIGO' | translate}}</label>
                      <input type="text" id="codigo" name="codigo" pInputText formControlName="codigo"
                             maxlength="6"
                             (change)="validarCodigo()" numero-entero-reactive/>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && f.codigo.errors">
                        <i class="fa fa-close"></i>{{ 'NIVELES.MSG_CODREQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="codExiste">
                        <i class="fa fa-close"></i>{{ 'NIVELES.MSG_CODIGOEXISTE' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-6 lg:col-6" *ngIf="editando">
                    <div class="div-form">
                      <label>* {{ 'LBL_CODIGO' | translate }}</label>
                      <label class="falso-combo-texto"><strong>{{nivel.codigo}}</strong></label>
                    </div>
                  </div>
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <label for="nombre">* {{ 'LBL_NOMBRE' | translate}}</label>
                      <input type="text" id="nombre" name="nombre" pInputText formControlName="nombre"
                             maxlength="44"
                             capitalize-reactive/>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && f.nombre.errors">
                        <i class="fa fa-close"></i>{{ 'NIVELES.MSG_NOMREQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 p-mg-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox binary="true" id="indicadorManejaTasa" name="indicadorManejaTasa"
                                  label="{{ 'NIVELES.LBL_MANEJATASA' | translate}}"
                                  formControlName="indicadorManejaTasa"></p-checkbox>
                    </div>
                  </div>
                  <div class="col-12 p-mg-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox binary="true" id="indicadorAprueba" name="indicadorAprueba"
                                  label="{{ 'NIVELES.LBL_APRUEBA' | translate}}"
                                  formControlName="indicadorAprueba"></p-checkbox>
                    </div>
                  </div>
                  <div class="col-12 p-mg-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox binary="true" id="indicadorHabilitado" name="indicadorHabilitado"
                                  label="{{ 'NIVELES.LBL_HABILITADO' | translate}}" (onChange)="cambioHabilitado($event)"
                                  formControlName="indicadorHabilitado"></p-checkbox>
                    </div>
                  </div>
                  <div class="col-12 p-mg-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox binary="true" id="indicadorManejaDctoTasa" name="indicadorManejaDctoTasa"
                                  label="{{ 'NIVELES.LBL_DCTOTASA' | translate}}"
                                  formControlName="indicadorManejaDctoTasa"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="grid form-footer-buttons">
                  <div class="form-group col-12" *ngIf="!guardando">
                    <a (click)="goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                    <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
                  </div>
                  <div class="form-group col-12" *ngIf="guardando">
                    <i class="fa fa-refresh fa-spin fa-fw"></i>
                    <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
                  </div>
                </div>
              </form>
            </p-accordionTab>
            <p-accordionTab header="{{ 'NIVELES.LBL_ASIGNACIONRANGOS' | translate}}" *ngIf="mostrarSeccion">
              <form [formGroup]="formularioR" (ngSubmit)="onSubmitRango()">
                <div class="row">
                  <div class="col-12" style="display: flex">
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label for="nombre">* {{ 'LBL_NOMBRE' | translate}}</label>
                        <input type="text" id="nombreRango" name="nombreRango" pInputText formControlName="nombre"
                               maxlength="45"/>
                        <div class="p-message p-messages-error p-corner-all"
                             *ngIf="submittedRangos && fr.nombre.errors">
                          <i class="fa fa-close"></i>{{ 'NIVELES.MSG_NOMREQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <label for="nombre">* {{ 'NIVELES.LBL_RANGOMAXIMO' | translate}}</label>
                      <input type="text" id="rangoMaximo" name="rangoMaximo" pInputText formControlName="rangoMaximo"
                             maxlength="14" [decimales]="6" [entero]="7"
                             numero-decimal-reactive/>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submittedRangos && fr.rangoMaximo.errors">
                        <i class="fa fa-close"></i>{{ 'NIVELES.MSG_RANGOMAXIMOREQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                      <p-checkbox binary="true" id="indicadorHabilitadoR" name="indicadorHabilitadoR"
                                  label="{{ 'NIVELES.LBL_HABILITADO' | translate}}"
                                  formControlName="indicadorHabilitado"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="grid form-footer-buttons">
                  <div class="form-group col-12" *ngIf="!guardandoR">
                    <a (click)="goBackR()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                    <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
                  </div>
                  <div class="form-group col-12" *ngIf="guardandoR">
                    <i class="fa fa-refresh fa-spin fa-fw"></i>
                    <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
                  </div>
                </div>
              </form>
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <p-table [columns]="columnasR" [loading]="carNivelesR" #dtr
                           [value]="nivelesRangos" selectionMode="single" dataKey="idNivelRango"
                           [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                            class="text-center">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                      <tr [pSelectableRow]="row">
                        <td>{{row.nombre}}</td>
                        <td>{{row.rangoMaximo}}</td>
                        <td class="text-center">
                          <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                        </td>
                        <td class="text-center">
                          <div class="btn-group" role="group">
                            <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                                    title="{{'BTN_VISUALIZAR' | translate}}" pButton
                                    (click)="updateRango(row)"></button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="columns.length" class="text-center">
                          {{ 'MSG_NOHAYREGISTROS' | translate}}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-accordionTab>

            <!-- Niveles tasas -->
            <p-accordionTab header="{{ 'NIVELES.LBL_ASIGNACIONRANGOSTASAMINIMA' | translate}}" *ngIf="puedeManejarTasa">
              <app-nivel-rango-tasa-usuario [nivel]="nivel"></app-nivel-rango-tasa-usuario>
            </p-accordionTab>
            <!-- Niveles tasas -->
            <p-accordionTab header="{{ 'NIVELES.LBL_ASIGNACIONDCTOTASA' | translate}}" *ngIf="manejaDctoTasa">
              <app-nivel-descuento-tasa [nivel]="nivel"></app-nivel-descuento-tasa>
            </p-accordionTab>

          </p-accordion>



        </div>
      </div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
